module.exports = __webpack_public_path__ + "img/5.124a42db.png";